<template>
  <ConfirmDialog group="wizard-modal">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="p-dialog-confirm p-dialog-confirm-cancel-add-event">
        <IconExclaim />

        <div class="modal-header">{{ message.header }}</div>

        <p>{{ message.message }}</p>

        <div class="p-dialog-confirm--footer">
          <Button @click="rejectCallback" class="close-button">
            {{ message.rejectProps.label }}
          </Button>
          <Button @click="acceptCallback">
            {{ message.acceptProps.label }}
          </Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>

  <ConfirmDialog group="headless">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="p-dialog-confirm">
        <div class="modal-header">{{ message.header }}</div>

        <p>{{ message.message }}</p>

        <div class="p-dialog-confirm--footer">
          <Button @click="rejectCallback" class="close-button">{{
            message.rejectProps.label
          }}</Button>
          <Button @click="acceptCallback">{{ message.acceptProps.label }}</Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>

  <ConfirmDialog group="alert">
    <template #container="{ message, acceptCallback }">
      <div class="p-dialog-confirm">
        <div class="modal-header">{{ message.header }}</div>

        <p>{{ message.message }}</p>

        <div class="p-dialog-confirm--footer">
          <Button @click="acceptCallback">{{ message.acceptProps.label }}</Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>
</template>

<script setup lang="ts">
import { Button, ConfirmDialog } from 'primevue';

import IconExclaim from '@/icons/IconExclaim.svg?component';
</script>
